// remove file after update

import { connect } from 'react-redux';

import {
    CategoryProductListContainer as SourceCategoryProductListContainer,
    mapStateToProps,
    mapDispatchToProps
} from 'SourceComponent/CategoryProductList/CategoryProductList.container';

export class CategoryProductListContainer extends SourceCategoryProductListContainer {
    getIsLoading() {
        const {
            filter,
            isLoading,
            isMatchingListFilter,
            isCurrentCategoryLoaded
        } = this.props;

        /**
         * In case the wrong category was passed down to the product list,
         * show the loading animation, it will soon change to proper category.
         */
        if (filter.categoryIds === -1) {
            return true;
        }

        /**
         * Do not request page, if category is not yet loaded
         * without this command the products are requested twice:
         * 1. Once with global default sorting
         * 2. Once with category default sortingZ
         */
        if (!isCurrentCategoryLoaded) {
            return true;
        }

        if (!navigator.onLine) {
            return false;
        }

        // if the filter expected matches the last requested filter
        if (isMatchingListFilter) {
            return false;
        }

        return isLoading;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryProductListContainer);
